// Default avatar based on gender
export const DEFAULT_AVATARS = {
  M: "https://cdn-icons-png.flaticon.com/512/3774/3774299.png", // Male doctor
  F: "https://cdn-icons-png.flaticon.com/512/3774/3774298.png", // Female doctor
  default: "https://cdn-icons-png.flaticon.com/512/3774/3774299.png", // Default
};

export const getAvatarUrl = (imageUrl: string, gender?: "M" | "F" | null): string => {
  if (imageUrl && imageUrl.trim() !== "") return imageUrl;
  if (gender === "F") return DEFAULT_AVATARS.F;
  if (gender === "M") return DEFAULT_AVATARS.M;
  return DEFAULT_AVATARS.default;
};
